import { TranslationService } from '../services/translation.service'
import {
  CountryRecycablilityInfo,
  RecyclabilityCountry,
} from '../types/recyclability'

const translationService = new TranslationService()

export const RECYCLABILITY_COUNTRIES: Array<RecyclabilityCountry> = [
  'Canada',
  'Hong Kong',
]

export const COUNTRY_RECYCLABILITY_OPTIONS: Array<CountryRecycablilityInfo> = [
  {
    country: 'Hong Kong',
    recyclabilityStatuses: [
      {
        name: 'Waste Paper',
        foreignName: '廢紙',
        localName: translationService.getWastePaperText(),
        symbolPath:
          'assets/sustainability_highlights/country_recycling_symbols/hong_kong/waste_paper.png',
      },
      {
        name: 'Plastic Bottles',
        foreignName: '膠樽',
        localName: translationService.getPlasticBottlesText(),
        symbolPath:
          'assets/sustainability_highlights/country_recycling_symbols/hong_kong/plastic_bottles.png',
      },
      {
        name: 'Aluminum Cans',
        foreignName: '鋁罐',
        localName: translationService.getAluminumCansText(),
        symbolPath:
          'assets/sustainability_highlights/country_recycling_symbols/hong_kong/aluminum_cans.png',
      },
    ],
  },
]

export const RECYCLABILITY_COUNTRY_OPTIONS = {
  CANADA: RECYCLABILITY_COUNTRIES[0],
  HONG_KONG: RECYCLABILITY_COUNTRIES[1],
}
